import { useSupplyTargetingFormField } from 'modules/campaigns/modules/common-campaign-form/components/SupplyTargeting/hooks/useSupplyTargetingFormField';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const useSupplyTargetingAndSiteTargetingValidation = () => {
    const isReachEstimatorSupplyTargetingAndSiteTargetingWarningEnable = useConfigMatch({
        [FEATURE_FLAGS.REACH_ESTIMATOR_SUPPLY_TARGETING_AND_SITE_TARGETING_WARNING]: 'true',
    });
    const { value: hasSupplyTargeting } = useSupplyTargetingFormField();
    const { value: includedSites } = useFormFieldValue({ field: 'campaignTargeting.publisherTargeting.include' });
    const { value: excludedSites } = useFormFieldValue({ field: 'campaignTargeting.publisherTargeting.exclude' });

    const hasIncludedSites = !!includedSites?.length;
    const hasExcludedSites = !!excludedSites?.length;
    const shouldShowIncludeWarning =
        isReachEstimatorSupplyTargetingAndSiteTargetingWarningEnable && hasIncludedSites && hasSupplyTargeting;
    const shouldShowExcludeWarning =
        isReachEstimatorSupplyTargetingAndSiteTargetingWarningEnable && hasExcludedSites && hasSupplyTargeting;
    return { shouldShowIncludeWarning, shouldShowExcludeWarning };
};
